import { useState } from 'react';
import { Box, Button } from '@material-ui/core';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { useIntl } from 'umi';
import CardListMLStyled from './CardListMLStyled';

const CardListML = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const [collapse, setCollapse] = useState(false);
  const cardList = props.cardList;
  // const cardList = props.cardList || [
  //   {
  //     cardTitle: '满减券',
  //     cardDesc: ['例：满100元减20元', '便于合理控制活动成本'],
  //     imgUrl: require('@/assets/img/shoes_three.jpg'),
  //   },
  //   {
  //     cardTitle: '折扣券',
  //     cardDesc: ['例：满100元打9折', '提高销量和客单价'],
  //     imgUrl: require('@/assets/img/shoes_two.jpg'),
  //   },
  //   {
  //     cardTitle: '礼品券',
  //     cardDesc: ['用于兑换指定礼品', '吸引顾客消费'],
  //     imgUrl: require('@/assets/img/shoes_one.jpg'),
  //   },
  //   {
  //     cardTitle: '满减券',
  //     cardDesc: ['例：满100元减20元', '便于合理控制活动成本'],
  //     imgUrl: require('@/assets/img/shoes_four.jpg'),
  //   },
  //   {
  //     cardTitle: '折扣券',
  //     cardDesc: ['例：满100元打9折', '提高销量和客单价'],
  //     imgUrl: '',
  //   },
  //   {
  //     cardTitle: '礼品券',
  //     cardDesc: ['用于兑换指定礼品', '吸引顾客消费'],
  //     imgUrl: '',
  //   },
  //   {
  //     cardTitle: '满减券',
  //     cardDesc: ['例：满100元减20元', '便于合理控制活动成本'],
  //     imgUrl: '',
  //   },
  //   {
  //     cardTitle: '折扣券',
  //     cardDesc: ['例：满100元打9折', '提高销量和客单价'],
  //     imgUrl: '',
  //   },
  //   {
  //     cardTitle: '礼品券',
  //     cardDesc: ['用于兑换指定礼品', '吸引顾客消费'],
  //     imgUrl: '',
  //   },
  // ];

  const cardHeight = React.useMemo(() => {
    const number = cardList?.length;
    return Math.ceil(number / 3) * 224;
  }, [cardList]);

  function click(cardItem, e) {
    e.preventDefault();
    // e.stopPropagation();
    props.handleClick && props.handleClick(cardItem);
  }

  return (
    <CardListMLStyled cardHeight={cardHeight}>
      <Box className={collapse ? 'collapse card-list' : ' card-list'}>
        {cardList.map((cardItem) => (
          <Box className="card" key={cardItem.cardTitle}>
            <Box
              className="card-content"
              style={{
                backgroundColor: cardItem?.disabled ? '#C9C9C9' : '#1565c0',
              }}
            >
              <Box
                className="left-content"
                data-log={JSON.stringify({
                  oid: cardItem.oid,
                  events: ['_ev', '_ec'],
                  params: {
                    initUrl: window.location.origin + window.location.pathname,
                  },
                })}
              >
                <div className="title">{cardItem.cardTitle}</div>
                <div className="desc">
                  <span>{cardItem.cardDesc[0]}</span>
                  <span>{cardItem.cardDesc[1]}</span>
                </div>
                {/* 添加按钮点击事件 */}
                <Button
                  onClick={(e) => !cardItem?.disabled && click(cardItem, e)}
                  style={{
                    color: cardItem?.disabled ? '#C9C9C9' : '#1565c0',
                    cursor: cardItem?.disabled && 'no-drop',
                  }}
                >
                  {cardItem.buttonText ||
                    formatMessage({ id: 'comm.action.btn.15' })}
                </Button>
              </Box>
              <Box className="right-img">
                <img
                  alt=""
                  src={cardItem.imgUrl}
                  style={{
                    width: '200px',
                    height: '200px',
                    // borderRadius: '4px',
                  }}
                />
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
      {cardList?.length > 3 && (
        <Box
          className="toggle"
          onClick={() => {
            setCollapse(!collapse);
          }}
        >
          <SvgIconML name={collapse ? 'close' : 'open'} />
        </Box>
      )}
    </CardListMLStyled>
  );
};
export default CardListML;
